
export enum ModuleFormat {
    // онлайн курсы
    Online = 1,
    // офлайн-курсы
    Offline = 2,
    // pre-recorded курсы
    PreRecorded = 3
}
export enum ModuleFormat {
    // онлайн курсы
    Online = 1,
    // офлайн-курсы
    Offline = 2,
    // pre-recorded курсы
    PreRecorded = 3
}